document.documentElement.classList.add('pounce-pogo-theme');

if (!customElements.get('pounce-sticky-buy')) {
  customElements.define('pounce-sticky-buy', class PounceStickyBuy extends HTMLElement {
    connectedCallback() {
      this.variantInput = this.querySelector('input[name="id"]');
      this.submitButton = this.querySelector('[type="submit"]');
      this.submitLabel = this.submitButton?.querySelector('span');
      this.price = this.querySelector('[data-sticky-price]');
      this.mainButton = [...document.querySelectorAll('.product-form__submit')]
        .find((button) => !this.contains(button));

      if (this.mainButton && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(([entry]) => {
          this.classList.toggle('is-visible', !entry.isIntersecting);
        }, { threshold: 0.1 });
        this.observer.observe(this.mainButton);
      } else {
        this.classList.add('is-visible');
      }

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          const { variant, html, sectionId } = data;
          if (!variant || !this.variantInput) return;

          this.variantInput.value = variant.id;
          this.variantInput.disabled = !variant.available;
          this.submitButton.disabled = !variant.available;
          this.submitLabel.textContent = variant.available ? window.variantStrings.addToCart : window.variantStrings.soldOut;

          const nextPrice = html?.querySelector(`#price-${sectionId} .price-item--sale, #price-${sectionId} .price-item--regular`);
          if (nextPrice && this.price) this.price.textContent = nextPrice.textContent.trim();
        });
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.unsubscribe?.();
    }
  });
}
